import { RouteObject } from "react-router";

import * as Sentry from "@sentry/react";

import PageError from "@/helpers/components/Errors/PageError";

export const ProfileRoutes: RouteObject = {
	path: "profile/*",
	children: [
		{
			index: true,
			lazy: async () => {
				const { Profile } = await import(
					"@/components/Application/AdminMenu/Profile"
				);
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={({ error, componentStack, resetError }) => (
								<PageError
									error={error}
									componentStack={componentStack}
									reset={resetError}
								/>
							)}
						>
							<Profile />
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
	],
};
